module.exports = __webpack_public_path__ + "static/media/drumstick-bite.b167141c.svg";